export default __webpack_public_path__ + "static/media/play-store-curved.png";